const http = uni.$u.http

let data = [];
data.length
/**
 * 历史行程列表

 * @param data
 * @returns {HttpPromise<any>}
 */
export const getAssignedItineraryLogList = (data ={}) => http.get('app/car/assignedItineraryLogList',{params: {...data}});